import { useEffect } from 'react'
import { useThemeStore } from '@/store/themeStore'

export function MatrixRain() {
  const theme = useThemeStore(s => s.theme)

  useEffect(() => {
    if (theme !== 'dark') return

    const canvas = document.createElement('canvas')
    const ctx = canvas.getContext('2d')
    if (!ctx) return

    canvas.width = window.innerWidth
    canvas.height = window.innerHeight
    canvas.style.position = 'fixed'
    canvas.style.top = '0'
    canvas.style.left = '0'
    canvas.style.zIndex = '0'
    canvas.style.pointerEvents = 'none'
    canvas.style.opacity = '0.1'

    document.body.appendChild(canvas)

    const matrix = '01010011011001010111010001110100011010010110111001100111011100110010000001010000010011110101010001000001010101000100111101001000'
    const matrixArray = matrix.split('')
    const fontSize = 14
    const columns = canvas.width / fontSize
    const drops = Array(Math.floor(columns)).fill(1)

    function draw() {
      ctx!.fillStyle = 'rgba(0, 8, 17, 0.1)'
      ctx!.fillRect(0, 0, canvas.width, canvas.height)
      ctx!.fillStyle = '#00ff88'
      ctx!.font = `${fontSize}px Roboto Mono, monospace`

      for (let i = 0; i < drops.length; i++) {
        const text = matrixArray[Math.floor(Math.random() * matrixArray.length)]
        ctx!.fillText(text, i * fontSize, drops[i] * fontSize)
        if (drops[i] * fontSize > canvas.height && Math.random() > 0.975) {
          drops[i] = 0
        }
        drops[i]++
      }
    }

    const interval = setInterval(draw, 100)

    const handleResize = () => {
      canvas.width = window.innerWidth
      canvas.height = window.innerHeight
    }
    window.addEventListener('resize', handleResize)

    return () => {
      clearInterval(interval)
      window.removeEventListener('resize', handleResize)
      document.body.removeChild(canvas)
    }
  }, [theme])

  return null
}
